import { Grid } from '@mui/material';
import React, { KeyboardEvent, useEffect, useRef, useState } from 'react';

import { ModalContent, ModalFooter, StyledBox, StyledModalBox } from './DispatchManifestFragment.styles';
import { DispatchManifestGridFragment } from './DispatchManifestGridFragment/DispatchManifestGridFragment';
import { PartSearchData } from '../../../../@types';
import { PartTypeBulkLiveSearchDataInsertionType } from '../../../../@types/part-type.type';
import { NSPartLocationList, SearchCode } from '../../../../@types/part.type';
import { Accordian } from '../../../../components/atoms/Accordian';
import { AdvanceLiveSearchBox } from '../../../../components/atoms/AdvanceLiveSearchBox';
import { Button, ButtonColorProps } from '../../../../components/atoms/Button';
import { LiveSearchListItem } from '../../../../components/atoms/LiveSearchBox';
import { Modal } from '../../../../components/atoms/Modal';
import { Typography } from '../../../../components/atoms/Typography';
import { PartSearchItem } from '../../../../components/molecules/PartSearchItem';
import { DispatchManifestDataType, DispatchManifestList } from '../../../../components/templates/DispatchManifestList';
import { COLORS } from '../../../../configs/colors';
import { SerialisedType } from '../../../../configs/enums';
import { GRID_SPACING } from '../../../../configs/ui-constants';
import { useAdvanceBulkSearchSerials, useAdvanceSearchPartTypes, useSearchDispatchParts } from '../../../../queries/live-search-query';
import { SAMPLE_PARTTYPE_BULK_LIVESEARCH_INSERTION_DATA } from '../../../../constants/addStock';
import { useGetNSPartByPartTypeAndLocation } from '../../../../queries/part-query';
import { getHasCodeForPartTypeSearch, manifestDataMapper, manifestExportDataMapper } from '../../../../utils/shipment';
import { CONDITION_ORDER, DispatchManifestFragmentProps, SELECTED_DATA, SelectedData } from '.';
import { INITIAL_DISPATCH_MANIFEST, S_HASH } from '../../../../constants/shipment';
import { DispatchNSInputPopup } from '../../../../components/organisms/DispatchNSInputPopup';
import { useExportDispatchManifest } from '../../../../queries/uploadedfiles-query';
import { downloadFile } from '../../../../utils/file-utils';
import { parseExcelData } from '../../../../utils/common';
import { PartTypeSearchItem } from '../../../../components/molecules/PartTypeSearchItem';
import { DispatchManifestRowItemValueType } from '../../../../components/organisms/DispatchManifestRowItem';

export const DispatchManifestFragment: React.FC<DispatchManifestFragmentProps> = ({
  applicableNodeId,
  sourceLocationId,
  sourceLocationName,
  shipmentId,
  isNew,
  manifestData,
  onChangeManifestData,
  onChangeExportManifestData,
  onExport
}) => {
  const [manifestValues, setManifestValues] = useState<DispatchManifestDataType>(INITIAL_DISPATCH_MANIFEST);
  const [isEnterPressed, setIsEnterPressed] = useState<boolean>(false);
  const [serialSearchItems, setSerialSearchItems] = useState('');
  const [advanceBulkSearchData, setAdvanceBulkSearchData] = useState<PartTypeBulkLiveSearchDataInsertionType>(SAMPLE_PARTTYPE_BULK_LIVESEARCH_INSERTION_DATA);
  const [searchItem, setSearchItem] = useState('');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedPartType, setSelectedPartType] = useState<SelectedData>(SELECTED_DATA);
  const [selectedLocation, setSelectedLocation] = useState<SelectedData>(SELECTED_DATA);
  const [locationList, setLocationList] = useState<NSPartLocationList[]>([]);
  const [isPaste, setIsPaste] = useState(false);
  const [isSerialisedPopupOpen, setIsSerialisedPopupOpen] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);

  const advanceSearchPartTypes = useAdvanceSearchPartTypes();
  const advanceBulkSearchSerials = useAdvanceBulkSearchSerials();
  const searchParts = useSearchDispatchParts();
  const getNSPartByPartTypeAndLocation = useGetNSPartByPartTypeAndLocation(selectedPartType?.id, selectedLocation?.id, false, true);
  const exportDispatchManifest = useExportDispatchManifest();

  const handleAddNewSerialised = (partLiveSearchData: PartSearchData, index: number, bulkSerialsList?: PartSearchData[], bulkSerialIndex?: number) => {
    if (partLiveSearchData && partLiveSearchData.id) {
      const newItem = {
        selected: true,
        condition: partLiveSearchData.partCondition?.name,
        conditionCode: partLiveSearchData.conditionCode,
        partId: partLiveSearchData.id,
        serial: partLiveSearchData.serial1,
        softwareVersion: partLiveSearchData.software?.version,
        softwareVersionId: partLiveSearchData.software?.id,
        hardwareVersion: partLiveSearchData.hardware?.version,
        hardwareVersionId: partLiveSearchData.hardware?.id,
        firmwareVersion: partLiveSearchData.firmware?.version,
        firmwareVersionId: partLiveSearchData.firmware?.id,
        fleetTag: partLiveSearchData.fleetTag || '',
        fleetTagId: partLiveSearchData.fleetTagId,
        location: partLiveSearchData.locationName,
        locationId: partLiveSearchData.locationId
      };
      let foundData: DispatchManifestRowItemValueType | undefined;
      foundData = manifestValues.serialisedManifestData.find((item) => item.partTypeId === partLiveSearchData?.partTypeId);
      const bulkSerialsMatchingPartType = bulkSerialsList?.find((serial) => serial.partTypeId === partLiveSearchData?.partTypeId);
      
      if (bulkSerialsList && bulkSerialsList?.length > 1 && bulkSerialsMatchingPartType) {
        foundData = {
          id: foundData?.id || index,
          partTypeId: foundData?.partTypeId || bulkSerialsMatchingPartType.partTypeId,
          partTypeName: foundData?.partTypeName || bulkSerialsMatchingPartType.partType.name,
          partTypeNo: foundData?.partTypeNo || bulkSerialsMatchingPartType.partType.number,
          items: [ ...(foundData?.items || []), ...bulkSerialsList.slice(0, bulkSerialIndex).map((serial) => {
            return {
              selected: true,
              condition: serial.partCondition?.name,
              conditionCode: serial.conditionCode,
              partId: serial.id,
              serial: serial.serial1,
              softwareVersion: serial.software?.version,
              softwareVersionId: serial.software?.id,
              hardwareVersion: serial.hardware?.version,
              hardwareVersionId: serial.hardware?.id,
              firmwareVersion: serial.firmware?.version,
              firmwareVersionId: serial.firmware?.id,
              fleetTag: serial.fleetTag || '',
              fleetTagId: serial.fleetTagId,
              location: serial.locationName,
              locationId: serial.locationId
            };
          })],
          quantity: 1,
          serialisation: SerialisedType.Serialised
        };
      }
      
      if(foundData) {
        if (foundData.items?.some((item) => item.partId === partLiveSearchData.id))
          return 0;
        const items = [...foundData.items, newItem];
        const rowData = { ... foundData, items: items };
        setManifestValues(prevState=>{
          const updatedSerialisedManifestData = prevState.serialisedManifestData.map((data) => data.id === (foundData as DispatchManifestRowItemValueType).id ? rowData : data);
          if (rowData && bulkSerialsList && bulkSerialsList?.length > 1 && index === (bulkSerialsList.length - 1) &&
              !prevState.serialisedManifestData.some((item) => item.partTypeId === rowData.partTypeId)) {
            updatedSerialisedManifestData.push(rowData);
          }
          return { 
            ...prevState, 
            serialisedManifestData: updatedSerialisedManifestData
          };
        });
      } else {
        const rowData = {
          id: index,
          partTypeId: partLiveSearchData.partTypeId,
          partTypeName: partLiveSearchData.partType?.name || partLiveSearchData.name,
          partTypeNo: partLiveSearchData.partType?.number || partLiveSearchData?.partTypeNumber || '',
          items: [newItem],
          serialisation: SerialisedType.Serialised
        };
        setManifestValues(prevState=>{
          return { 
            ...prevState, 
            serialisedManifestData: [...prevState.serialisedManifestData, rowData] 
          };
        });
      }
    } else {
      const newItem = {
        selected: false,
        serial: partLiveSearchData ? partLiveSearchData.serial1 : searchItem
      };
      const rowData = {
        id: index,
        partTypeId: 0,
        partTypeName: '',
        partTypeNo: '',
        items: [newItem],
        serialisation: SerialisedType.Unknown
      };
      setManifestValues(prevState=>{
        return { 
          ...prevState, 
          serialisedManifestData: [...prevState.serialisedManifestData, rowData] 
        };
      });
    }
    setSearchItem('');
    setIsEnterPressed(false);
  };

  const handleAddNewNonSerialised = (partTypeLiveSearchData: NSPartLocationList, index: number) => {
    const newItem = {
      selected: true,
      ns_part_id: partTypeLiveSearchData.id,
      conditionCode: partTypeLiveSearchData.conditionCode || '',
      condition: partTypeLiveSearchData.condition || '',
      fleetTag: partTypeLiveSearchData.fleetTagName || '',
      fleetTagId: partTypeLiveSearchData.fleetTagId || 0,
      location: partTypeLiveSearchData.locationName || '',
      locationId: partTypeLiveSearchData.locationId || 0,
    };
    const rowData = {
      id: index,
      partTypeId: selectedPartType.id,
      partTypeName: selectedPartType.name,
      partTypeNo: selectedPartType.number || '',
      quantity: 0,
      max: partTypeLiveSearchData.quantity,
      items: [newItem],
      serialisation: SerialisedType.Consumable,
      partTypeCategoryCode: selectedPartType.category
    };
    const nonserialisedData = [...manifestValues.nonSerializedManifestData, rowData];
    nonserialisedData && setManifestValues({ 
      ...manifestValues, 
      nonSerializedManifestData: nonserialisedData 
    });
    setSearchItem('');
    setIsEnterPressed(false);
  };

  useEffect(() => {
    if (searchParts.data && isEnterPressed) {
      const enteredData = searchParts.data[0];
      setSearchItem(enteredData?.name);
      handleAddNewSerialised(enteredData, manifestValues.serialisedManifestData.length);  
    }
  }, [searchParts.data]);
  
  useEffect(() => {
    isEnterPressed && searchItem && onApiInvoke(searchItem);
  }, [isEnterPressed]);

  useEffect(() => {
    onChangeManifestData(manifestDataMapper(manifestValues));
    onChangeExportManifestData(manifestExportDataMapper(manifestValues));
  }, [manifestValues]);

  useEffect(() => {
    if (!!selectedPartType.id && !!selectedLocation.id) {      
      getNSPartByPartTypeAndLocation.refetch();
    }
  }, [selectedPartType, selectedLocation]);

  useEffect(() => {
    sourceLocationId &&     
      setSelectedLocation({
        ...selectedLocation,
        id: sourceLocationId
      });
  }, [sourceLocationId]);

  useEffect(() => {
    if (getNSPartByPartTypeAndLocation.data) {
      // arranging data in order of given array
      const arrangedData: NSPartLocationList[] = getNSPartByPartTypeAndLocation.data.sort((a, b) => {
        const indexA = CONDITION_ORDER.indexOf(a.condition || '');
        const indexB = CONDITION_ORDER.indexOf(b.condition || '');
        return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
      }); 
      setLocationList(arrangedData);
    }
  }, [getNSPartByPartTypeAndLocation.data]);

  useEffect(() => {
    if (advanceBulkSearchSerials.data) {
      advanceBulkSearchSerials.data.map((liveSearchResult: PartSearchData, index: number) => {        
        handleAddNewSerialised(liveSearchResult, manifestValues.serialisedManifestData.length + index, advanceBulkSearchSerials.data, index);
      });
    }
  }, [advanceBulkSearchSerials.data]);

  useEffect(() => {
    if(advanceBulkSearchData && serialSearchItems.endsWith('\n')){
      const handleSearch = async () => {
        setIsEnterPressed(true);
        await advanceBulkSearchSerials.mutateAsync(advanceBulkSearchData);
        setSerialSearchItems('');
      };
    
      handleSearch();
    }
  }, [advanceBulkSearchData]);

  const bulkSearchInputValueOptimizer = (inputText: string) => {
    if (inputText) {
      const formatedManifestedData = parseExcelData(inputText || '') as Array<Array<string>>;
      const formatedManifestedAsFlatArray = ([] as string[]).concat(...formatedManifestedData);

      setAdvanceBulkSearchData({   
        searchableValues: formatedManifestedAsFlatArray,
        applicableNodeId: applicableNodeId
      });
    }
  };

  const onApiInvoke = async (searchableData: string, enterKeyPressed?: boolean) => {
    setSearchItem(searchableData);
    if(enterKeyPressed) {
      if(getHasCodeForPartTypeSearch(searchableData)) {
        const response = await advanceSearchPartTypes.mutateAsync({
          searchableValues: searchableData,
          applicableNodeId: `${applicableNodeId}`,
          searchType: 'dispatch'
        });

        return response.filter((responseItem) => responseItem.serialisation === SerialisedType.Consumable);
      }
      return await searchParts.mutateAsync({ name: searchableData.toUpperCase().startsWith(SearchCode.AM_PID) ? searchableData : S_HASH.concat(searchableData), applicableNodeIds: applicableNodeId });
    }

    const response = await advanceSearchPartTypes.mutateAsync({
      searchableValues: searchableData,
      applicableNodeId: `${applicableNodeId}`,
      searchType: 'dispatch'
    });

    return response;
  };

  const onClickExport = async (e: MouseEvent) => {
    e.stopPropagation();
    if (isNew) {
      onExport();
    } else if (shipmentId) {
      const exportFileLink = await exportDispatchManifest.mutateAsync(shipmentId);
      downloadFile(exportFileLink.url, `shipment-${shipmentId}-manifest`);
    }
  };

  return (
    <Accordian title={
      <Grid container justifyContent="space-between" flex={1}>
        <Grid>
          <Typography>Manifest</Typography>
        </Grid>
        <Grid mr={2}>
          <Button onClick={onClickExport}>Export Manifest</Button>
        </Grid>
      </Grid>
    } defaultExpanded={true}>
      {isNew ? 
        <Grid container justifyContent="space-between">
          <Grid mb={GRID_SPACING} size={{ xs: 12 }}>
            <StyledBox>
              <AdvanceLiveSearchBox
                inputRef={inputRef}
                title={isPaste ? 'Serial 1 Copy Paste' : 'PartType/ Part Search'}
                timeOffset={400}
                value={serialSearchItems || ''}
                overrideOnEnterKey={true}
                onClearValue={() => {
                  setIsEnterPressed(false);
                  setIsPaste(false);
                  setSerialSearchItems('');
                }}
                renderItem={(props: any, option: any) => { 
                  if (!isPaste) {
                    return (
                      <LiveSearchListItem {...props}>
                        { option.serial1 ? <PartSearchItem data={option} searchType="dispatch" /> : <PartTypeSearchItem data={option} searchType="dispatch" /> }
                        
                      </LiveSearchListItem>
                    );
                  }
                }}
                onChange={(partTypeLiveSearchData: any) => {
                  if('number' in partTypeLiveSearchData) {
                    setSelectedPartType({
                      id: partTypeLiveSearchData.id,
                      name: partTypeLiveSearchData.name,
                      number: partTypeLiveSearchData.number,
                      category: partTypeLiveSearchData.categoryCode
                    });
                    if (partTypeLiveSearchData?.serialisation === SerialisedType.Serialised) { 
                      setIsSerialisedPopupOpen(true);
                    } else {
                      setIsOpen(true);
                    }
                  }
                  else {
                    handleAddNewSerialised(partTypeLiveSearchData, manifestValues.serialisedManifestData.length);  
                  }
                }}
                onTextChange={(event) => {
                  setSerialSearchItems(event.target.value);
                  bulkSearchInputValueOptimizer(event.target.value);
                }}
                onApiInvoke={onApiInvoke}
                onPaste={() => {
                  setIsPaste(true);
                }}
                onKeyDown={async (event: KeyboardEvent<HTMLDivElement>) => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                    if (serialSearchItems) {
                      setIsEnterPressed(true);
                      await advanceBulkSearchSerials.mutateAsync(advanceBulkSearchData);
                      setSerialSearchItems('');
                    }
                  }
                  setIsPaste(false);
                }}
                isPaste={isPaste}
                onChangeMatchingAttribute="id"
              />
            </StyledBox>
          </Grid>
          <Grid container justifyContent="space-between" width="100%">
            <DispatchManifestList
              manifestData={manifestValues}
              onChange={(val) => setManifestValues(val)}    
            />
          </Grid>
        </Grid> : 
        <DispatchManifestGridFragment manifestData={manifestData || []} shipmentId={shipmentId || 0} />
      }
      <DispatchNSInputPopup
        isOpen={isOpen}
        onChange={(val) => {
          setSelectedLocation({
            id: val?.id,
            name: val?.name || ''
          });
        }}
        onClick={(selectedItem) => {
          handleAddNewNonSerialised(selectedItem, manifestValues.nonSerializedManifestData.length);
          setIsOpen(false);
          inputRef.current?.focus();   
        }}
        onCancel={() => {
          setIsOpen(false);
          setSelectedPartType({
            id: 0,
            name: '',
            number: '',
          });
          setSearchItem('');
          inputRef.current?.focus();
        }}
        onClose={() => {
          setIsOpen(false);
          inputRef.current?.focus();
        }}
        sourceLocation={sourceLocationId}
        sourceLocationName={sourceLocationName}
        partTypeName={selectedPartType?.name || ''}
        locationData={locationList}
      />
      <Modal
        open={isSerialisedPopupOpen}
        onClose={() => setIsSerialisedPopupOpen(false)}
        disableAutoFocus
      >
        <StyledModalBox>
          <ModalContent>
            <Typography textColor={COLORS.Red}>This is a serialized Part Type.</Typography>
            <Typography textColor={COLORS.Red}>Go back and enter the serial number.</Typography>
          </ModalContent>
          <ModalFooter>
            <Button color={ButtonColorProps.Error} onClick={() => setIsSerialisedPopupOpen(false)}>
              Cancel
            </Button>
          </ModalFooter>
        </StyledModalBox>
      </Modal>
    </Accordian>
  );
};